import { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import { updateLayoutsInLocal } from 'pages/dashboard/homePageLayout/utils/helper';
import { IVersionBasedHomePageLayout } from '../../utils/model';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const { showAlert } = useContext(AppContext);

	const updateLayout = (updatedData: IVersionBasedHomePageLayout) => {
		try {
			setShowLoader(true);
			const existingData: IVersionBasedHomePageLayout = _get(location, ['state', 'rowData']);
			updateLayoutsInLocal(existingData, updatedData);
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: IVersionBasedHomePageLayout) => {
		updateLayout(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
